import { Music, Film, Shirt, Trophy, Briefcase } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { TypePreset, ColorPreset } from "@/types/portfolio.types";

export type { TypePreset, ColorPreset };

export const TYPE_PRESETS: TypePreset[] = [
  { type: "artist", label: "Artist", icon: Music, defaultColor: "violet" },
  { type: "brand", label: "Brand", icon: Shirt, defaultColor: "amber" },
  { type: "ip", label: "IP", icon: Trophy, defaultColor: "cyan" },
  { type: "label", label: "Label", icon: Film, defaultColor: "red" },
];

export const DEFAULT_ICON: LucideIcon = Briefcase;

export const COLOR_PRESETS: ColorPreset[] = [
  { color: "text-violet-500", bgClass: "bg-violet-500/15", activeBg: "bg-violet-500/15 ring-violet-500/40", swatch: "bg-violet-500" },
  { color: "text-red-500", bgClass: "bg-red-500/15", activeBg: "bg-red-500/15 ring-red-500/40", swatch: "bg-red-500" },
  { color: "text-amber-500", bgClass: "bg-amber-500/15", activeBg: "bg-amber-500/15 ring-amber-500/40", swatch: "bg-amber-500" },
  { color: "text-cyan-500", bgClass: "bg-cyan-500/15", activeBg: "bg-cyan-500/15 ring-cyan-500/40", swatch: "bg-cyan-500" },
  { color: "text-emerald-500", bgClass: "bg-emerald-500/15", activeBg: "bg-emerald-500/15 ring-emerald-500/40", swatch: "bg-emerald-500" },
  { color: "text-blue-500", bgClass: "bg-blue-500/15", activeBg: "bg-blue-500/15 ring-blue-500/40", swatch: "bg-blue-500" },
  { color: "text-pink-500", bgClass: "bg-pink-500/15", activeBg: "bg-pink-500/15 ring-pink-500/40", swatch: "bg-pink-500" },
  { color: "text-orange-500", bgClass: "bg-orange-500/15", activeBg: "bg-orange-500/15 ring-orange-500/40", swatch: "bg-orange-500" },
];

export function getTypePreset(type: string): TypePreset | null {
  return TYPE_PRESETS.find((p) => p.type === type) ?? null;
}

export function getIconForType(type: string): LucideIcon {
  return getTypePreset(type)?.icon ?? DEFAULT_ICON;
}

export function getColorPreset(colorClass: string): ColorPreset {
  return COLOR_PRESETS.find((p) => p.color === colorClass) ?? COLOR_PRESETS[0];
}
